<template>
  <div class="container">
    <div class="header">
      <van-icon
          class="header-return"
          name="arrow-left"
          size="25"
          color="#333333"
          @click="onClickHeaderReturn()"
      />
      Terms of Service & Privacy Policy
      {{ $route.params.title }}
    </div>

    <div class="flex flex-col round-wrap m-4 content">
      <div class="text-center text-18px"> "Terms of Service" & "Privacy Policy"</div>
      <span class="mt-4 text-14px">TERMS OF SERVICE</span>
      <div class="mt-4 text-14px">
        We are IVISION TECH INC. ("Company," "we," "us," "our"), a company registered and located at 11818 Clark St., Building A, Arcadia, California 91006.
        <br/> <br/>
        We operate the mobile application OMNI Connector (the "App"), as well as other related products and services that refer or link to these legal terms (the "Legal Terms") (collectively, the "Services").
        <br/> <br/>
        You can contact us by phone at (626) 256-3449, email at ivisiontechinc@gmail.com, or by mail to 11818 Clark St., Building A, Arcadia, California 91006, United States.
        <br/> <br/>
        By downloading the App and connecting your vape device to your phone, via NFC or otherwise, or by using the App, you agree to abide by these Legal Terms. Users may be required to create an account to gain access to certain features of the App; however, creation of an account is not a prerequisite to your agreement to abide by these Legal Terms.
        <br/> <br/>
        These Legal Terms constitute a legally binding agreement made between you, whether personally or on behalf of an entity ("you" and the possessive “your”), and IVISION TECH INC., concerning your access to and use of the Services. You agree that by accessing the Services, you have read, understood, and agreed to be bound by all of these Legal Terms. IF YOU DO NOT AGREE WITH ALL OF THESE LEGAL TERMS, THEN YOU ARE EXPRESSLY PROHIBITED FROM USING THE SERVICES AND YOU MUST DISCONTINUE USE IMMEDIATELY.
        <br/> <br/>
        Supplemental terms and conditions or documents that may be posted on the Services from time to time are hereby expressly incorporated herein by reference. We reserve the right, in our sole discretion, to make changes or modifications to these Legal Terms from time to time. We will alert you about any changes by updating the "Last updated" date of these Legal Terms, and you waive any right to receive specific notice of each such change. It is your responsibility to periodically review these Legal Terms to stay informed of updates. You will be subject to, and will be deemed to have been made aware of and to have accepted, the changes in any revised Legal Terms by your continued use of the Services after the date such revised Legal Terms are posted.
        <br/> <br/>
        The Services are intended for users who are at least 21 years old. Persons under the age of 21 are not permitted to use or register for the Services.
        <br/> <br/>
        We recommend that you print a copy of these Legal Terms for your records. <br/>
      </div>
    </div>

    <div class="flex flex-col round-wrap text-center agree-wrap ml-4 mr-4">
      <div>Clicking "Agree and Continue" indicates that you have read and agreed to the updated <span
          class="blue-text">"Terms of Service"</span> and <span class="blue-text">"Privacy Policy"</span>.
      </div>
      <div class="agree-btn mt-4" @click="onAgreeClick(true)">Agree & Continue</div>
      <div class="disagree third-color" @click="onAgreeClick(false)">Disagree & Exit</div>
    </div>
  </div>
</template>
<script>
import bus from "@/util/EventBus";
import userMixin from "@/mixins/userMixin";
import user from "@/api/user";

export default {
  name: "PrivacyPolicy",
  mixins: [userMixin],
  props: {
    title: {
      type: String,
      default: ""
    },
    type: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      content: null
    };
  },
  mounted() {
  },
  methods: {
    async onAgreeClick(checked) {
      if (checked) {
        try {
          await user.agreementRead();
          await this.$store.dispatch("user/updateUser", {agreementReadStatus:1})
          await this.$router.replace("/Enterprise");
        } catch (e) {
          console.log(e)
          this.$toast({
            message: e
          });
        }
      } else {
        this.$router.back();
      }
      // this.$store.commit('setCheckPrivacy',checked)
      // this.$router.go(-1);
    },
    onClickHeaderReturn() {
      this.$store.dispatch('user/logout')
    }
  }
};
</script>


<style scoped lang="less">
.container {
  height: 100%;
  display: flex;
  flex-direction: column;

  .header {

    position: fixed;
    top: 0;
    width: 100%;
    height: 60px;
    min-height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    color: #333333;

    .header-return {
      position: absolute;
      left: 10px;
    }
  }
}

.content {
  margin-top: 70px;
  height: 63vh;
  overflow: auto;
}

.round-wrap {
  padding: 16px;
  font-size: 14px;
  background: white;
  border-radius: 12px;
}

.agree-wrap {
  height: calc(100vh - 60px - 36px - 63vh)
}

.blue-text {
  color: #679AFF;
}

.agree-btn {
  background: #121212;
  border-radius: 12px;
  height: 40px;
  line-height: 40px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
}

.disagree {
  margin-top: 16px

}
</style>